<template>
    <div class="TodayTimeSheet">
        <el-input v-model="emp_searching" class="float-right my-3" placeholder="Search by employee name and id" style="width: 350px"></el-input>
        <table v-loading="is_timesheet_loading" class="timsheet-table">
            <thead>
                <tr>
                    <th>Employee Id</th>
                    <th>Employee</th>
                    <th>&nbsp;</th>
                    <th>TIME IN-TIME OUT</th>
                    <th>BREAK <span style="font-size: 0.6rem;">(HH:mm)</span></th>
                    <th>DURATION <span style="font-size: 0.6rem;">(HH:mm)</span></th>
                    <th>COST <span style="font-size: 0.6rem;">(INR)</span></th>
                    <th>STATUS</th>
                </tr>
            </thead>

            <div style="width: 100%; max-height: 400px; overflow-y: auto;">
                <tbody v-for="(time_slot, time_index) in time_sheet_list" :key="time_index">

                    <!-- for backdated entires -->
                    <tr v-for="(emp, emp_index1) in time_slot.backdated_start_time_emp_list" :key="emp_index1+new Date().getTime()" v-if="time_index == 0" class="relative" :style="[emp.is_toggled ? { height: '200px', background: '#fcfcff' } : '']">
                        <td>
                            <div class="title">ID</div>
                        </td>
                        <td>
                            <div style="display: flex;">
                                <div class="title ellipsis">
                                    {{ emp.employee_full_name }}
                                </div>
                                <span v-if="emp.shift_date != time().format('YYYY-MM-DD')">
                                    <i class="el-icon-star-on" style="color: #e29d5a;" :title="emp.shift_date"></i>
                                </span>
                            </div>

                            <div class="mt-2 task-highliter" :style="[ emp.employee_department == 'Management' ? { backgroundColor: '#cd5cff' } : emp.employee_department == 'Team Members' ? { backgroundColor: '#099989' } : { backgroundColor: '#999' } ]" style="margin-top: 5px;">{{ emp.employee_department }}</div>
                        </td>
                        <td>
                            <div class="title">Actual</div>
                            <div class="mt-8">Scheduled</div>
                        </td>
                        <td>
                            <div class="title" v-if="emp.shift_start_datetime">
                                {{ emp.shift_start_datetime | timeFilter }}
                                <span v-if="emp.shift_start_datetime && emp.shift_end_datetime">-</span>
                                {{ emp.shift_end_datetime | timeFilter }}
                            </div>

                            <div v-else>-</div>
                            <div class="mt-8">
                                {{ emp.schedule_start_time | timeFilter }} - {{ emp.schedule_end_time | timeFilter }}
                            </div>
                            <!-- <el-popover
                                placement="top"
                                width="300"
                                trigger="hover">
                                <table class="scheduled-shift-table">
                                    <thead>
                                        <tr v-if="emp.schedule_start_time && emp.schedule_end_time">
                                            <th>Scheduled Time</th>
                                            <th>{{ emp.schedule_start_time | timeFilter }} - {{ emp.schedule_end_time | timeFilter }}</th>
                                        </tr>
                                    </thead>
                                    <tbody v-if="emp.scheduled_breaks.length">
                                        <tr v-for="(brk, brk_index) in emp.scheduled_breaks" :key="brk_index">
                                            <td class="font-bold">Break {{ brk_index + 1 }}</td>
                                            <td>{{ brk.start_time | timeFilter }} - {{ brk.end_time | timeFilter }}</td>
                                        </tr>
                                    </tbody>
                                    <tbody v-else>
                                        <tr>
                                            <td colspan="2" style="text-align: center; font-size: 10px; font-weight: 600; color: #e29d5a; padding: 5px;">
                                                No data available
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <div slot="reference" class="mt-8">
                                    {{ emp.schedule_start_time | timeFilter }} - {{ emp.schedule_end_time | timeFilter }}
                                </div>
                            </el-popover> -->
                        </td>
                        <td class="text-center">
                            <div v-if="emp.break_duration" class="">
                                {{ emp.break_duration + ' Hrs' }}
                            </div>
                            <!-- <el-popover
                                placement="bottom"
                                width="300"
                                trigger="hover">
                                <table class="scheduled-shift-table">
                                    <thead>
                                        <tr v-if="emp.break_duration">
                                            <th>Break Duration</th>
                                            <th>{{ emp.break_duration }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-if="emp.break1_start_datetime">
                                            <td class="font-bold">Break 1</td>
                                            <td>
                                                {{ emp.break1_start_datetime | timeFilter }} <span v-if="emp.break1_start_datetime && emp.break1_end_datetime">-</span> {{ emp.break1_end_datetime | timeFilter }}
                                            </td>
                                        </tr>
                                        <tr v-if="emp.break2_start_datetime">
                                            <td class="font-bold">Break 2</td>
                                            <td>
                                                {{ emp.break2_start_datetime | timeFilter }} <span v-if="emp.break2_start_datetime && emp.break2_end_datetime">-</span> {{ emp.break2_end_datetime | timeFilter }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <div v-if="emp.break_duration" slot="reference" class="">
                                    {{ emp.break_duration + ' Hrs' }}
                                </div>
                            </el-popover> -->

                            <div v-if="!emp.break_duration" class="mt-8">perfect
                                -
                            </div>
                        </td>
                        <td class="text-center">
                            <div class="title">
                                {{ emp.shift_duration ? emp.shift_duration + ' Hrs' : '-' }}
                            </div>

                            <!-- <div class="mt-1" style="color: #ef5753;">(01:30 Hrs)</div>

                            <div class="mt-4">12:30 Hrs</div> -->
                        </td>
                        <td class="text-center">
                            <div class="title">{{ emp.actual_total_cost }}</div>

                            <!-- <div class="mt-8" style="color: #ef5753;">(INR 150)</div> -->
                        </td>
                        <td class="text-center">
                            <div v-if="emp.cur_activity == 'shift_end'" :style="[emp.cur_activity == 'shift_end' ? {color: '#25b57e'} : '']" class="capitalize">
                                Completed
                            </div>

                            <div v-if="emp.cur_activity != 'shift_end'" class="mb-2 capitalize">
                                {{ emp.cur_activity == 'shift_start' || (emp.cur_activity == 'break_end') ? 'In Progress' : emp.cur_activity == 'break_start' ? 'Break' : '' }}
                            </div>

                            <div v-if="emp.late_by" class="mt-1" style="color: #ef5753;">Late by {{ emp.late_by }}</div>

                            <div v-if="emp.early_left_by" class="mt-4" style="color: #ef5753;">Early out by {{ emp.early_left_by}}</div>
                        </td>
                    </tr>

                    <tr v-if="time_slot.emp_list.length" style="background-color: #f2f2f2;">
                        <td class="font-bold row-bg">{{time_slot.duration }}</td>
                        <td class="row-bg">&nbsp;</td>
                        <td class="row-bg">&nbsp;</td>
                        <td class="row-bg">&nbsp;</td>
                        <td class="row-bg">&nbsp;</td>
                        <td class="row-bg">&nbsp;</td>
                        <td class="row-bg">&nbsp;</td>
                        <!-- <td class="row-bg">&nbsp;</td> -->
                        <!-- <td class="row-bg">&nbsp;</td> -->
                        <td style="width: 3%;" class="row-bg">&nbsp;</td>
                    </tr>

                    <!-- for current date entries -->
                    <tr v-for="(emp, emp_index) in time_slot.emp_list" :key="emp_index" class="relative" :style="[emp.is_toggled ? { height: '200px', background: '#fcfcff' } : '']">
                        <td>
                            <div v-if="emp.employee_full_name" class="title ellipsis">
                                {{ emp.employee_full_name }}
                            </div>

                            <div class="mt-4 task-highliter" :style="[ emp.employee_department == 'Management' ? { backgroundColor: '#cd5cff' } : emp.employee_department == 'Team Members' ? { backgroundColor: '#099989' } : { backgroundColor: '#999' } ]" style="margin-top: 5px;">{{ emp.employee_department }}</div>
                        </td>

                        <td>
                            <div class="title">Actual</div>
                            <div class="mt-8">Scheduled</div>
                        </td>
                        
                        <td>
                            <div class="title" v-if="emp.shift_start_datetime">
                                {{ emp.shift_start_datetime | timeFilter }}
                                <span v-if="emp.shift_start_datetime && emp.shift_end_datetime">-</span>
                                {{ emp.shift_end_datetime | timeFilter }}
                            </div>

                            <div v-else>-</div>

                            <el-popover
                                placement="top"
                                width="300"
                                trigger="hover">
                                <table class="scheduled-shift-table">
                                    <thead>
                                        <tr v-if="emp.schedule_start_time && emp.schedule_end_time">
                                            <th>Scheduled Time</th>
                                            <th>{{ emp.schedule_start_time | timeFilter }} - {{ emp.schedule_end_time | timeFilter }}</th>
                                        </tr>
                                    </thead>
                                    <tbody v-if="emp.scheduled_breaks.length">
                                        <tr v-for="(brk, brk_index) in emp.scheduled_breaks" :key="brk_index">
                                            <td class="font-bold">Break {{ brk_index + 1 }}</td>
                                            <td>{{ brk.start_time | timeFilter }} - {{ brk.end_time | timeFilter }}</td>
                                        </tr>
                                    </tbody>
                                    <tbody v-else>
                                        <tr>
                                            <td colspan="2" style="text-align: center; font-size: 10px; font-weight: 600; color: #e29d5a; padding: 5px;">
                                                No data available
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <div slot="reference" class="mt-8" v-if="!emp.weekoff && !emp.leave && !emp.no_shift">
                                    {{ emp.schedule_start_time | timeFilter }} - {{ emp.schedule_end_time | timeFilter }}
                                </div>

                                <div slot="reference" class="mt-8" v-if="emp.weekoff">
                                    Weekly off
                                </div>

                                <div slot="reference" class="mt-8" v-if="emp.leave">
                                    Leave
                                </div>

                                <div slot="reference" class="mt-8" v-if="emp.no_shift">
                                    No shift
                                </div>
                            </el-popover>
                        </td>

                        <td>
                            <el-popover
                                placement="bottom"
                                width="300"
                                trigger="hover">
                                <table class="scheduled-shift-table">
                                    <thead>
                                        <tr v-if="emp.break_duration">
                                            <th>Break Duration</th>
                                            <th>{{ emp.break_duration }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-if="emp.break1_start_datetime">
                                            <td class="font-bold">Break 1</td>
                                            <td>
                                                {{ emp.break1_start_datetime | timeFilter }} <span v-if="emp.break1_start_datetime && emp.break1_end_datetime">-</span> {{ emp.break1_end_datetime | timeFilter }}
                                            </td>
                                        </tr>
                                        <tr v-if="emp.break2_start_datetime">
                                            <td class="font-bold">Break 2</td>
                                            <td>
                                                {{ emp.break2_start_datetime | timeFilter }} <span v-if="emp.break2_start_datetime && emp.break2_end_datetime">-</span> {{ emp.break2_end_datetime | timeFilter }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <div v-if="emp.break_duration" class="title" slot="reference">
                                    {{ emp.break_duration + ' Hrs' }}
                                </div>
                            </el-popover>
                            
                            <div style="color: #ef5753;" class="mt-1">(00:12 Hrs)</div>

                            <div class="mt-4">(00:12 Hrs)</div>

                            <div v-if="!emp.break_duration">
                                -
                            </div>
                        </td>

                        <td>
                            <div class="title">
                                {{ emp.shift_duration ? emp.shift_duration + ' Hrs' : '-' }}
                            </div>

                            <div class="mt-1" style="color: #ef5753;">(01:30 Hrs)</div>

                            <div class="mt-4">12:30 Hrs</div>
                        </td>

                        <td>
                            <div class="title">{{ emp.actual_total_cost }}</div>

                            <div class="mt-8" style="color: #ef5753;">(INR 150)</div>
                        </td>
                        <!-- <td>
                            <div>
                                <el-popover
                                    placement="bottom"
                                    width="300"
                                    trigger="hover">

                                    <div slot="reference">
                                        <span class="title">In</span>&nbsp;&nbsp;
                                        <span>
                                            {{ emp.shift_start_distance > 900 ? (emp.shift_start_distance / 1000).toFixed(2) + ' Km' : emp.shift_start_distance ? emp.shift_start_distance + ' M' : '-' }}
                                        </span>
                                        <span v-if="emp.shift_start_distance">away</span>
                                    </div>

                                </el-popover>
                            </div>

                            <div class="mt-8">
                                <el-popover
                                placement="bottom"
                                width="300"
                                trigger="hover">

                                    <div slot="reference">
                                        <span class="title">Out</span>&nbsp;&nbsp;
                                        <span>
                                            {{ emp.shift_end_distance > 900 ? (emp.shift_end_distance / 1000).toFixed(2) + ' Km' : emp.shift_end_distance ? emp.shift_end_distance + ' M' : '-' }}
                                        </span>
                                        <span v-if="emp.shift_end_distance">away</span>
                                    </div>

                                </el-popover>
                            </div>
                        </td> -->

                        <td>
                            <div v-if="emp.cur_activity == 'shift_end'" :style="[emp.cur_activity == 'shift_end' ? {color: '#25b57e'} : '']" class="capitalize">
                                Completed
                            </div>

                            <div v-if="emp.cur_activity != 'shift_end'" class="mb-2 capitalize">
                                {{ emp.cur_activity == 'shift_start' || (emp.cur_activity == 'break_end') ? 'In Progress' : emp.cur_activity == 'break_start' ? 'Break' : '' }}
                            </div>

                            <div v-if="emp.late_by" class="mt-1" style="color: #ef5753;">Late by {{ emp.late_by }}</div>

                            <div v-if="emp.early_left_by" class="mt-4" style="color: #ef5753;">Early out by {{ emp.early_left_by}}</div>
                        </td>

                        <td>
                            <div v-if="emp.cur_activity == 'shift_end'">
                                <img src="../../../assets/images/paused.png" width="18">
                            </div>

                            <!-- passing selected emp obj and status that needs to be changed -->
                            <div v-if="emp.cur_activity == 'shift_start' || emp.cur_activity == 'break_end'" style="display: flex; justify-content: space-around;">
                                <!-- if break 1 is alreadytaken then hide this button, break can be assigned only two times -->
                                <div v-if="!emp.break2_start_datetime && !emp.break2_end_datetime" @click="changeCurrentShiftStatus(emp, 'break_start')">
                                    <img src="../../../assets/images/coffee-cup.png" width="18" class="cursor-pointer">
                                    <div style="font-size: 0.6rem;">Take Break</div>
                                </div>
                                <div @click="changeCurrentShiftStatus(emp, 'shift_end')">
                                    <img src="../../../assets/images/cancel.png" width="18" class="cursor-pointer">
                                    <div style="font-size: 0.6rem;">End Shift</div>
                                </div>
                            </div>

                            <div v-if="emp.cur_activity == 'break_start'" @click="changeCurrentShiftStatus(emp, 'break_end')">
                                <img src="../../../assets/images/coffee.png" width="18" class="cursor-pointer">
                                <div style="font-size: 0.6rem;">End Break</div>
                            </div>

                            <div v-if="emp.cur_activity == ''" @click="changeCurrentShiftStatus(emp, 'shift_start')">
                                <img src="../../../assets/images/play.png" width="18" class="cursor-pointer">
                                <div style="font-size: 0.6rem;">Start Shift</div>
                            </div>
                        </td>

                        <!-- <td style="width: 3%;">
                            <div class="flex items-center">
                                <span v-if="emp.shift_start_datetime" @click="toggleEditView(time_index, emp_index, 'CURRENT_DATE_ENTRIES')">
                                    <i v-if="!emp.is_toggled" class="el-icon-arrow-down" style="font-size: 1rem; color: #c6c6c6; font-weight: bold; cursor: pointer;"></i>
                                    <i v-if="emp.is_toggled" class="el-icon-arrow-up" style="font-size: 1rem; color: #c6c6c6; font-weight: bold; cursor: pointer;"></i>
                                </span>

                                <el-popover
                                    v-if="emp.shift_start_datetime"
                                    placement="left"
                                    width="50"
                                    trigger="click">
                                    <div>
                                        <div class="option-menu" @click="toggleEditView(time_index, emp_index, 'CURRENT_DATE_ENTRIES')">Edit</div>
                                        <div class="option-menu" @click="deleteTimesheet(emp)">Delete</div>
                                    </div>
                                    <img slot="reference" src="../../../assets/images/menu.png" style="width: 22px; cursor: pointer;">
                                </el-popover>
                            </div>
                        </td> -->

                        <!-- table to edit employee who has current day shift -->
                        <!-- <table v-if="emp.is_toggled" style="width: 100%; padding: 10px 0; position: absolute; bottom: 0;">
                            <tbody>
                                <tr style="border: none;"> 

                                    <td class="font-bold" style="height: 60px; width: 20%; padding: 10px;">
                                        <label class="text-left">START TIME</label>
                                        <el-time-picker
                                            v-model="emp.edit_timesheet_start_hours"
                                            size="mini"
                                            style="width: 100%;"
                                            :picker-options="{
                                                format: ('HH:mm')
                                            }"
                                            placeholder="Start Time"
                                            @change="emp.edit_timesheet_end_hours = ''; emp.edit_timesheet_break1_start_hours = ''; emp.edit_timesheet_break1_end_hours = ''; emp.edit_timesheet_break2_start_hours = ''; emp.edit_timesheet_break2_end_hours = ''">
                                        </el-time-picker>
                                    </td>
                                    <td class="font-bold" style="height: 60px; width: 20%; padding: 10px;">
                                        <label class="text-left">END TIME</label>
                                        <el-time-picker
                                            v-model="emp.edit_timesheet_end_hours"
                                            size="mini"
                                            style="width: 100%;"
                                            placeholder="Start Time"
                                            :picker-options="timesheetEndTimePickerOptions(emp)"
                                            :disabled="!emp.edit_timesheet_start_hours">
                                        </el-time-picker>
                                    </td>
                                    
                                </tr>

                                <tr style="border: none;">
                                    <td class="font-bold" style="height: 60px; width: 20%; padding: 10px;">
                                        <label class="text-left">BREAK 1 START TIME</label>
                                        <el-time-picker
                                            v-model="emp.edit_timesheet_break1_start_hours"
                                            size="mini"
                                            style="width: 100%;"
                                            :picker-options="timesheetBreak1StartTimePickerOption(emp)"
                                            placeholder="Start Time">
                                        </el-time-picker>
                                    </td>
                                    <td class="font-bold" style="height: 60px; width: 20%; padding: 10px;">
                                        <label class="text-left">BREAK 1 END TIME</label>
                                        <el-time-picker
                                            v-model="emp.edit_timesheet_break1_end_hours"
                                            size="mini"
                                            style="width: 100%;"
                                            placeholder="End Time"
                                            :disabled="!emp.edit_timesheet_break1_start_hours"
                                            :picker-options="timesheetBreak1EndTimePickerOption(emp)"
                                            @change="emp.edit_timesheet_break2_start_hours = ''; emp.edit_timesheet_break2_end_hours = ''">
                                        </el-time-picker>
                                    </td>
                                    <td class="font-bold" style="height: 60px; width: 20%; padding: 10px;">
                                        <label class="text-left">BREAK 2 START TIME</label>
                                        <el-time-picker
                                            v-model="emp.edit_timesheet_break2_start_hours"
                                            size="mini"
                                            style="width: 100%;"
                                            placeholder="Start Time"
                                            :disabled="emp.edit_timesheet_break1_start_hours !='' && emp.edit_timesheet_break1_end_hours == ''"
                                            :picker-options="timesheetBreak2StartTimePickerOption(emp)">
                                        </el-time-picker>
                                    </td>
                                    <td class="font-bold" style="height: 60px; width: 20%; padding: 10px;">
                                        <label class="text-left">BREAK 2 END TIME</label>
                                        <el-time-picker
                                            v-model="emp.edit_timesheet_break2_end_hours"
                                            size="mini"
                                            style="width: 100%;"
                                            :disabled="emp.edit_timesheet_break1_start_hours !='' && emp.edit_timesheet_break1_end_hours == '' || !emp.edit_timesheet_break2_start_hours"
                                            :picker-options="timesheetBreak2EndTimePickerOption(emp)"
                                            placeholder="Start Time">
                                        </el-time-picker>
                                    </td>
                                    <td class="font-bold" style="height: 60px; width: 20%; padding: 10px;">
                                        <label class="text-left">&nbsp;</label>
                                        <el-button size="mini" type="success" class="action-btn" @click="updateTimesheet(emp)">SAVE</el-button>
                                    </td>
                                </tr>
                            </tbody>
                        </table> -->
                    </tr>
                </tbody>

                <!-- for weekly off wise emp list -->
                <tbody v-if="weekly_off_assigned_emp_list.length">
                    <tr style="background-color: #f2f2f2;">
                        <td class="font-bold row-bg">Weekly Off</td>
                        <td class="row-bg">&nbsp;</td>
                        <td class="row-bg">&nbsp;</td>
                        <td class="row-bg">&nbsp;</td>
                        <td class="row-bg">&nbsp;</td>
                        <td class="row-bg">&nbsp;</td>
                        <td class="row-bg">&nbsp;</td>
                        <td class="row-bg">&nbsp;</td>
                        <!-- <td class="row-bg">&nbsp;</td> -->
                        <td style="width: 3%;" class="row-bg">&nbsp;</td>
                    </tr>
                    <tr v-for="(emp, emp_index) in weekly_off_assigned_emp_list" :key="emp_index+new Date()">
                        <td>
                            <div v-if="emp.employee_full_name" class="title ellipsis">
                                {{ emp.employee_full_name }}
                            </div>

                            <div class="mt-4 task-highliter" :style="[ emp.employee_department == 'Management' ? { backgroundColor: '#cd5cff' } : emp.employee_department == 'Team Members' ? { backgroundColor: '#099989' } : { backgroundColor: '#999' } ]" style="margin-top: 5px;">{{ emp.employee_department }}</div>
                        </td>

                        <td>
                            <div class="title">Actual</div>
                            <div class="mt-8">Scheduled</div>
                        </td>

                        <td>
                            <div class="title">{{ emp.shift_start_datetime ? emp.shift_start_datetime : '-' }}</div>

                            <div class="mt-8">
                                Weekly Off
                            </div>
                        </td>

                        <td class="text-center">
                            <div v-if="emp.break_duration" class="title">
                                {{ emp.break_duration + ' Hrs' }}
                            </div>
                            
                            <!-- <div class="mt-1" style="color: #ef5753;">(00:12 Hrs)</div>

                            <div class="mt-4">(00:10 Hrs)</div> -->

                            <div class="mt-4" v-if="!emp.break_duration">
                                -
                            </div>
                        </td>

                        <td class="text-center">
                            <div class="title">
                                {{ emp.shift_duration ? emp.shift_duration + ' Hrs' : '-' }}
                            </div>

                            <!-- <div class="mt-1" style="color: #ef5753;">(01:30 Hrs)</div>

                            <div class="mt-4">12:30 Hrs</div> -->
                        </td>

                        <td class="text-center">
                            <div class="title">{{ emp.actual_total_cost }}</div>

                            <!-- <div class="mt-8" style="color: #ef5753;">(INR 150)</div> -->
                        </td>

                        <!-- <td class="text-center">
                            {{ emp.overtime_duration ? emp.overtime_duration + ' Hrs' : '-' }}
                        </td> -->

                        <td>
                            <div>
                                <span class="title">In</span>&nbsp;&nbsp;
                                <span>
                                    {{ emp.shift_start_distance > 900 ? (emp.shift_start_distance / 1000).toFixed(2) + ' Km' : emp.shift_start_distance ? emp.shift_start_distance + ' M' : '-' }}
                                </span>
                                <span v-if="emp.shift_start_distance">away</span>
                            </div>

                            <div class="mt-8">
                                <span class="title">Out</span>&nbsp;&nbsp;
                                <span>
                                    {{ emp.shift_end_distance > 900 ? (emp.shift_end_distance / 1000).toFixed(2) + ' Km' : emp.shift_end_distance ? emp.shift_end_distance + ' M' : '-' }}
                                </span>
                                <span v-if="emp.shift_end_distance">away</span>
                            </div>
                        </td>

                        <td class="text-center">
                            <div class="mb-2 capitalize">
                                {{ emp.cur_activity }}
                            </div>
                        </td>

                        <td>
                            <div @click="openConfirmation(emp, 'REMOVE_WEEKLY_OFF', 'shift_start')">
                                <img src="../../../assets/images/play.png" width="18" class="cursor-pointer">
                                <div style="font-size: 0.6rem;">Start Shift</div>
                            </div>
                        </td>
                        <td style="width: 3%;">&nbsp;</td>
                    </tr>
                </tbody>

                <!-- for leave wise emp list -->
                <tbody v-if="leave_assigned_emp_list.length">
                    <tr style="background-color: #f2f2f2;">
                        <td class="font-bold row-bg">Leave</td>
                        <td class="row-bg">&nbsp;</td>
                        <td class="row-bg">&nbsp;</td>
                        <td class="row-bg">&nbsp;</td>
                        <td class="row-bg">&nbsp;</td>
                        <td class="row-bg">&nbsp;</td>
                        <td class="row-bg">&nbsp;</td>
                        <td class="row-bg">&nbsp;</td>
                        <!-- <td class="row-bg">&nbsp;</td> -->
                        <td style="width: 3%;" class="row-bg">&nbsp;</td>
                    </tr>

                    <tr v-for="(emp, emp_index) in leave_assigned_emp_list" :key="emp_index+new Date()">
                        <td>
                            <div v-if="emp.employee_full_name" class="title ellipsis">
                                {{ emp.employee_full_name }}
                            </div>

                            <div class="mt-4 task-highliter" :style="[ emp.employee_department == 'Management' ? { backgroundColor: '#cd5cff' } : emp.employee_department == 'Team Members' ? { backgroundColor: '#099989' } : { backgroundColor: '#999' } ]" style="margin-top: 5px;">{{ emp.employee_department }}</div>
                        </td>

                        <td>
                            <div class="title">Actual</div>
                            <div class="mt-8">Scheduled</div>
                        </td>

                        <td>
                            <div class="title">{{ emp.shift_start_datetime ? emp.shift_start_datetime : '-' }}</div>

                            <div class="mt-8">
                                Leave
                            </div>
                        </td>

                        <td class="text-center">
                            <div v-if="emp.break_duration" class="title">
                                {{ emp.break_duration + ' Hrs' }}
                            </div>

                            <!-- <div class="mt-1" style="color: #ef5753;">(00:12 Hrs)</div>

                            <div class="mt-4">(00:10 Hrs)</div> -->

                            <div class="mt-4" v-if="!emp.break_duration">
                                -
                            </div>
                        </td>

                        <td class="text-center">
                            <div class="title">
                                {{ emp.shift_duration ? emp.shift_duration + ' Hrs' : '-' }}
                            </div>

                            <!-- <div class="mt-1" style="color: #ef5753;">(01:30 Hrs)</div>

                            <div class="mt-4">12:30 Hrs</div> -->
                        </td>

                        <td class="text-center">
                            <div class="title">{{ emp.actual_total_cost }}</div>

                            <!-- <div class="mt-8" style="color: #ef5753;">(INR 150)</div> -->
                        </td>

                        <!-- <td class="text-center">
                            {{ emp.overtime_duration ? emp.overtime_duration + ' Hrs' : '-' }}
                        </td> -->

                        <td>
                            <div>
                                <span class="title">In</span>&nbsp;&nbsp;
                                <span>
                                    {{ emp.shift_start_distance > 900 ? (emp.shift_start_distance / 1000).toFixed(2) + ' Km' : emp.shift_start_distance ? emp.shift_start_distance + ' M' : '-' }}
                                </span>
                                <span v-if="emp.shift_start_distance">away</span>
                            </div>

                            <div class="mt-8">
                                <span class="title">Out</span>&nbsp;&nbsp;
                                <span>
                                    {{ emp.shift_end_distance > 900 ? (emp.shift_end_distance / 1000).toFixed(2) + ' Km' : emp.shift_end_distance ? emp.shift_end_distance + ' M' : '-' }}
                                </span>
                                <span v-if="emp.shift_end_distance">away</span>
                            </div>
                        </td>

                        <td class="text-center">
                            <div class="mb-2 capitalize">
                                {{ emp.cur_activity }}
                            </div>
                        </td>

                        <td>
                            <div @click="openConfirmation(emp, 'REMOVE_LEAVE', 'shift_start')">
                                <img src="../../../assets/images/play.png" width="18" class="cursor-pointer">
                                <div style="font-size: 0.6rem;">Start Shift</div>
                            </div>
                        </td>
                        <td style="width: 3%;">&nbsp;</td>
                    </tr>
                </tbody>

                <!-- for emp list -->
                <tbody v-if="employee_list.length">
                    <tr style="background-color: #f2f2f2;">
                        <td class="font-bold row-bg">No shift</td>
                        <td class="row-bg">&nbsp;</td>
                        <td class="row-bg">&nbsp;</td>
                        <td class="row-bg">&nbsp;</td>
                        <td class="row-bg">&nbsp;</td>
                        <td class="row-bg">&nbsp;</td>
                        <td class="row-bg">&nbsp;</td>
                        <td class="row-bg">&nbsp;</td>
                        <!-- <td class="row-bg">&nbsp;</td> -->
                        <td style="width: 3%;" class="row-bg">&nbsp;</td>
                    </tr>

                    <tr v-for="(emp, emp_index) in employee_list" :key="emp_index+new Date()">
                        <td>
                            <div v-if="emp.employee_full_name" class="title ellipsis">
                                {{ emp.employee_full_name }}
                            </div>

                            <div class="mt-4 task-highliter" :style="[ emp.employee_department == 'Management' ? { backgroundColor: '#cd5cff' } : emp.employee_department == 'Team Members' ? { backgroundColor: '#099989' } : { backgroundColor: '#999' } ]" style="margin-top: 5px;">{{ emp.employee_department }}</div>
                        </td>

                        <td>
                            <div class="title">Actual</div>
                            <div class="mt-8">Scheduled</div>
                        </td>

                        <td>
                            <div class="title">{{ emp.shift_start_datetime ? emp.shift_start_datetime : '-' }}</div>

                            <div class="mt-8">
                                No shift
                            </div>
                        </td>

                        <td class="text-center">
                            <div v-if="emp.break_duration" class="title">
                                {{ emp.break_duration + ' Hrs' }}
                            </div>

                            <!-- <div class="mt-1" style="color: #ef5753;">(00:12 Hrs)</div>

                            <div class="mt-4">(00:10 Hrs)</div> -->

                            <div class="mt-1" v-if="!emp.break_duration">
                                -
                            </div>
                        </td>

                        <td class="text-center">
                            <div class="title">
                                {{ emp.shift_duration ? emp.shift_duration + ' Hrs' : '-' }}
                            </div>

                            <!-- <div class="mt-1" style="color: #ef5753;">(01:30 Hrs)</div> -->

                            <!-- <div class="mt-4">12:30 Hrs</div> -->
                        </td>

                        <td class="text-center">
                            <div class="title">{{ emp.actual_total_cost }}</div>

                            <!-- <div class="mt-8" style="color: #ef5753;">(INR 150)</div> -->
                        </td>

                        <!-- <td class="text-center">
                            {{ emp.overtime_duration ? emp.overtime_duration + ' Hrs' : '-' }}
                        </td> -->

                        <td>
                            <div>
                                <span class="title">In</span>&nbsp;&nbsp;
                                <span>
                                    {{ emp.shift_start_distance > 900 ? (emp.shift_start_distance / 1000).toFixed(2) + ' Km' : emp.shift_start_distance ? emp.shift_start_distance + ' M' : '-' }}
                                </span>
                                <span v-if="emp.shift_start_distance">away</span>
                            </div>

                            <div class="mt-8">
                                <span class="title">Out</span>&nbsp;&nbsp;
                                <span>
                                    {{ emp.shift_end_distance > 900 ? (emp.shift_end_distance / 1000).toFixed(2) + ' Km' : emp.shift_end_distance ? emp.shift_end_distance + ' M' : '-' }}
                                </span>
                                <span v-if="emp.shift_end_distance">away</span>
                            </div>
                        </td>

                        <td class="text-center">
                            <div class="mb-2 capitalize">
                                {{ emp.cur_activity }}
                            </div>
                        </td>

                        <td>
                            <div @click="assignShiftToSelectedEmp(emp, 'shift_start')">
                                <img src="../../../assets/images/play.png" width="18" class="cursor-pointer">
                                <div style="font-size: 0.6rem;">Start Shift</div>
                            </div>
                        </td>

                        <td style="width: 3%;">&nbsp;</td>
                    </tr>
                </tbody>
            </div>
        </table>

        <div v-if="!time_sheet_list.length && !weekly_off_assigned_emp_list.length && !leave_assigned_emp_list.length && !employee_list.length" style="text-align: center; font-size: 14px; font-weight: 600; color: #e29d5a; padding: 15px;">
          No data available
        </div>
    </div>
</template>

<script>
import LabourPalnningService from "../../../services/labourPalnningService";
import axios from "axios";
import moment from 'moment';
import { functionsIn } from 'lodash';
import { EventBus } from "../../../eventBus";

export default {
    name: 'TodayTimeSheet',

    filters:{
        utcToLocaltimeFilter(time){
            if(time){
                var currentTime = new Date(time + ' UTC').toString();
                return moment(currentTime).format('HH:mm');
            }
        },
        utcToLocalDateFilter(time){
            if(time){
                var currentTime = new Date(time + ' UTC').toString();
                return moment(currentTime).format('YYYY-MM-DD HH:mm:ss');
            }
        },
        timeFilter(time){
            if(time){
                return moment(time).format('HH:mm');
            }
        },
    },

    props: {
        selectedStore: {
            type: String,
            default: () => ''
        },
        searchedEmployee:{
            type: String,
            default: () => ''
        }
    },

    data() {
        return {
            time_sheet_list: [],
            is_timesheet_loading: false,
            time: moment,
            employee_list: [],
            backdated_start_time_emp_list: [],
            weekly_off_assigned_emp_list: [],
            leave_assigned_emp_list: [],
            edit_timesheet_hours_range: [],
            edit_timesheet_minutes_range: [],
            function_list: [
                {
                    label: 'Veg',
                    value: 'veg'
                },
                {
                    label: 'Non Veg',
                    value: 'non veg'
                },
                {
                    label: 'POS',
                    value: 'pos'
                },
                {
                    label: 'Shift Manager',
                    value: 'shift manager'
                }
            ],
        }
    },

    watch: {
        selectedStore(newValue, oldValue){
            if(newValue){
                this.getTodaysTimesheetDetails();
            }
        }
    },

    mounted() {
        this.getTodaysTimesheetDetails();
    },

    methods: {
        timesheetEndTimePickerOptions(emp_obj){
            let end_time = '23:59:00';
            let obj = { selectableRange: `${moment(emp_obj.edit_timesheet_start_hours).format('HH:mm:ss')} - ${end_time}`, format: 'HH:mm' };

            return obj;
        },

        timesheetBreak1StartTimePickerOption(emp_obj){
            let obj = { format: 'HH:mm' };

            if(emp_obj.edit_timesheet_start_hours && emp_obj.edit_timesheet_end_hours){
                obj.selectableRange = `${moment(emp_obj.edit_timesheet_start_hours).format('HH:mm:ss')} - ${moment(emp_obj.edit_timesheet_end_hours).format('HH:mm:ss')}`;
            }else if(emp_obj.edit_timesheet_start_hours && !emp_obj.edit_timesheet_end_hours){
                obj.selectableRange = `${moment(emp_obj.edit_timesheet_start_hours).format('HH:mm:ss')} - 23:59:00`;
            }else{
                obj.selectableRange = `${moment(this.$options.filters.utcToLocalDateFilter(emp_obj.break1_start_datetime)).format('HH:mm:ss')} - ${moment(this.$options.filters.utcToLocalDateFilter(emp_obj.break1_end_datetime)).format('HH:mm:ss')}`;
            }

            return obj;
        },

        timesheetBreak1EndTimePickerOption(emp_obj){
            let obj = { format: 'HH:mm' };

            if(emp_obj.edit_timesheet_break1_start_hours && emp_obj.edit_timesheet_end_hours){
                obj.selectableRange = `${moment(emp_obj.edit_timesheet_break1_start_hours).format('HH:mm:ss')} - ${moment(emp_obj.edit_timesheet_end_hours).format('HH:mm:ss')}`;
            }else if(emp_obj.edit_timesheet_break1_start_hours && !emp_obj.edit_timesheet_end_hours){
                obj.selectableRange = `${moment(emp_obj.edit_timesheet_break1_start_hours)} - 23:59:00`;
            }else{
                obj.selectableRange = `${moment(this.$options.filters.utcToLocalDateFilter(emp_obj.break1_start_datetime)).format('HH:mm:ss')} - ${moment(this.$options.filters.utcToLocalDateFilter(emp_obj.break1_end_datetime)).format('HH:mm:ss')}`;
            }

            return obj;
        },

        timesheetBreak2StartTimePickerOption(emp_obj){
            let obj = { format: 'HH:mm' };

            if(emp_obj.edit_timesheet_start_hours && emp_obj.edit_timesheet_end_hours && emp_obj.edit_timesheet_break1_start_hours && emp_obj.edit_timesheet_break1_end_hours){
                obj.selectableRange = `${moment(emp_obj.edit_timesheet_break1_end_hours).format('HH:mm:ss')} - ${moment(emp_obj.edit_timesheet_end_hours).format('HH:mm:ss')}`;
            }else if(emp_obj.edit_timesheet_start_hours && !emp_obj.edit_timesheet_end_hours && !emp_obj.edit_timesheet_break1_start_hours && !emp_obj.edit_timesheet_break1_end_hours){
                obj.selectableRange = `${moment(emp_obj.edit_timesheet_start_hours).format('HH:mm:ss')} - 23:59:00`;
            }else if(emp_obj.edit_timesheet_start_hours && emp_obj.edit_timesheet_end_hours && !emp_obj.edit_timesheet_break1_start_hours && !emp_obj.edit_timesheet_break1_end_hours){
                obj.selectableRange = `${moment(emp_obj.edit_timesheet_start_hours).format('HH:mm:ss')} - ${moment(emp_obj.edit_timesheet_end_hours).format('HH:mm:ss')}`;
            }else if(emp_obj.edit_timesheet_start_hours && !emp_obj.edit_timesheet_end_hours && emp_obj.edit_timesheet_break1_start_hours && emp_obj.edit_timesheet_break1_end_hours){
                obj.selectableRange = `${moment(emp_obj.edit_timesheet_break1_end_hours)} - 23:59:00`;
            }else{
                obj.selectableRange = `${moment(this.$options.filters.utcToLocalDateFilter(emp_obj.break2_start_datetime)).format('HH:mm:ss')} - ${moment(this.$options.filters.utcToLocalDateFilter(emp_obj.break2_end_datetime)).format('HH:mm:ss')}`;
            }

            return obj;
        },

        timesheetBreak2EndTimePickerOption(emp_obj){
            let obj = { format: 'HH:mm' };

            if(emp_obj.edit_timesheet_start_hours && emp_obj.edit_timesheet_end_hours && emp_obj.edit_timesheet_break2_start_hours){
                obj.selectableRange = `${moment(emp_obj.edit_timesheet_break2_start_hours).format('HH:mm:ss')} - ${moment(emp_obj.edit_timesheet_end_hours).format('HH:mm:ss')}`;
            }else if(emp_obj.edit_timesheet_start_hours && !emp_obj.edit_timesheet_end_hours && emp_obj.edit_timesheet_break2_start_hours){
                obj.selectableRange = `${moment(emp_obj.edit_timesheet_break2_start_hours).format('HH:mm:ss')} - 23:59:00`;
            }else{
                obj.selectableRange = `${moment(this.$options.filters.utcToLocalDateFilter(emp_obj.break2_start_datetime)).format('HH:mm:ss')} - ${moment(this.$options.filters.utcToLocalDateFilter(emp_obj.break2_end_datetime)).format('HH:mm:ss')}`;
            }

            return obj;
        },

        toggleEditView(timslot_index, emp_index, entry_type){
            if(entry_type == 'BACK_DATED_ENTRIES'){
                this.time_sheet_list[timslot_index].backdated_start_time_emp_list[emp_index].is_toggled = !this.time_sheet_list[timslot_index].backdated_start_time_emp_list[emp_index].is_toggled;
            }else{
                this.time_sheet_list[timslot_index].emp_list[emp_index].is_toggled = !this.time_sheet_list[timslot_index].emp_list[emp_index].is_toggled;
            }

            // if current is active then close remaining all
            // for(let i=0; i<this.time_sheet_list.length; i++){
            //     for(let j=0; j<this.time_sheet_list[i].emp_list.length; j++){
            //         if(this.time_sheet_list[i].emp_list[j].employee != this.time_sheet_list[timslot_index].emp_list[emp_index].employee){
            //             this.time_sheet_list[i].emp_list[j].is_toggled = false;
            //         }
            //     }
            //     for(let j=0; j<this.time_sheet_list[i].backdated_start_time_emp_list.length; j++){
            //         console.log(this.time_sheet_list[i].backdated_start_time_emp_list[j])
            //         if(this.time_sheet_list[i].backdated_start_time_emp_list[j].employee != this.time_sheet_list[timslot_index].backdated_start_time_emp_list[emp_index].employee){
            //             this.time_sheet_list[i].backdated_start_time_emp_list[j].is_toggled = false;
            //         }
            //     }
            // }
        },

        getTodaysTimesheetDetails() {
            if(this.selectedStore){
                this.is_timesheet_loading = true;     //enabled loader

                let timesheet_params = {
                    start_date: moment().format('YYYY-MM-DD'),
                    end_date: moment().format('YYYY-MM-DD'),
                    filters: {
                        outlets: [this.selectedStore],
                        regions: [],
                        subregions: [],
                        countries: []
                    }
                };

                let store_time_params = {
                    start_date: moment().format('YYYY-MM-DD'),
                    end_date: moment().format('YYYY-MM-DD'),
                    outlet: this.selectedStore
                };

                axios.all([this.completeTimesheetDetails(timesheet_params), this.getStoreTime(store_time_params)])
                .then(axios.spread((timesheetRes, storeTimeRes) => {
                    // console.log("timesheetRes", timesheetRes);

                    if(timesheetRes.status == 200 && storeTimeRes.status == 200){
                        let time_sheet_list = JSON.parse(timesheetRes.data).timesheets;
                        let time_sheet_summary = JSON.parse(timesheetRes.data).summary;
                        let store_timing = JSON.parse(storeTimeRes.data);
                        // console.log("time_sheet_list", time_sheet_list);

                        let obj = {
                            scheduled_labour_hours: time_sheet_summary.scheduled_hours,
                            scheduled_labour_cost: Number(time_sheet_summary.scheduled_total_cost).toFixed(2),
                            actual_labour_hours: time_sheet_summary.actual_hours,
                            actual_labour_cost: (time_sheet_summary.actual_total_cost).toFixed(2),
                            total_leaves: time_sheet_summary.leave_count,
                            total_absents: time_sheet_summary.absent_count,
                            total_late: time_sheet_summary.late_by,
                            total_weekly_off: time_sheet_summary.weekoff_count,
                            total_overtime: Number(time_sheet_summary.overtime).toFixed(2),
                            total_early_out: time_sheet_summary.early_left_by,
                        }

                        // commit timesheet summary in vue store
                        this.$store.commit('commitTimesheetSummary', obj);

                        // calculate 60 mins duration
                        let interval = 60;
                        let period = "minutes";
                        let periods_in_a_day = moment.duration(1, "day").as(period);
                        let time_labels = [];
                        let start_time = store_timing.opening;
                        let start_time_moment = moment(start_time, "HH:mm");
                        for (let i = 0; i < periods_in_a_day; i += interval) {
                            start_time_moment.add(i === 0 ? 0 : interval, period);
                            let obj = {
                                time: start_time_moment.format("HH:mm"),
                                datetime: start_time_moment.format("YYYY-MM-DD HH:mm:ss")
                            };
                            time_labels.push(obj);
                            if (store_timing.closing == start_time_moment.format("HH:mm:ss")) {
                                break;
                            }
                        }
                        // console.log('storeTimeRes', time_labels);

                        if(time_sheet_list.length && time_labels.length){

                            let temp_time_sheet_list = [];
                            let temp_weekly_off_assigned_emp_list = [];
                            let temp_leave_assigned_emp_list = [];
                            let temp_emp_list = [];

                            this.time_sheet_list = [];
                            this.weekly_off_assigned_emp_list = [];
                            this.leave_assigned_emp_list = [];
                            this.employee_list = [];


                            // generate time slots e.g. 8-9, 9-10
                            let time_slots = [];

                            function getEndTimeByStartTime(start_time){
                                return moment(moment(start_time).add(1, 'hours')).format('YYYY-MM-DD HH:mm:ss');
                            }

                            for(let i=0; i<time_labels.length; i++){
                                let obj = {};

                                obj.start_time = time_labels[i].datetime;
                                obj.end_time = getEndTimeByStartTime(obj.start_time)
                                time_slots.push(obj);
                            }
                            // console.log('time_slots', time_slots);

                            for(let time=0; time<time_slots.length; time++){
                                let time_obj = {};

                                time_obj.duration = moment(time_slots[time].start_time).format('HH:mm') + ' - ' + moment(time_slots[time].end_time).format('HH:mm');
                                time_obj.emp_list = [];     //list where we will push emp whoes shift time is in duration
                                time_obj.backdated_start_time_emp_list = [];

                                for(var i=0; i<time_sheet_list.length; i++){

                                    let emp_obj = {
                                        employee_full_name: time_sheet_list[i].employee_full_name,
                                        employee: time_sheet_list[i].employee_id,
                                        user_id: time_sheet_list[i].user_id,
                                        outlet: time_sheet_list[i].store,
                                        shift_date: time_sheet_list[i].shift_date,
                                        function: '',
                                        employee_department: time_sheet_list[i].employee_department,

                                        shift_start_datetime: time_sheet_list[i].shift_start_datetime ? (this.$options.filters.utcToLocalDateFilter(time_sheet_list[i].shift_start_datetime)) : '',

                                        shift_end_datetime: time_sheet_list[i].shift_end_datetime ? (this.$options.filters.utcToLocalDateFilter(time_sheet_list[i].shift_end_datetime)) : '',

                                        schedule_start_time: time_sheet_list[i].scheduled_start_time ? moment(time_sheet_list[i].scheduled_start_time).format('YYYY-MM-DD HH:mm:ss') : '',
                                        schedule_end_time: time_sheet_list[i].scheduled_end_time ? moment(time_sheet_list[i].scheduled_end_time).format('YYYY-MM-DD HH:mm:ss') : '',

                                        // break1_start_datetime: time_sheet_list[i].break1_start_datetime,
                                        // break1_end_datetime: time_sheet_list[i].break1_end_datetime,
                                        // break2_start_datetime: time_sheet_list[i].break2_start_datetime,
                                        // break2_end_datetime: time_sheet_list[i].break2_end_datetime,

                                        break1_start_datetime: time_sheet_list[i].break1_start_datetime ? this.$options.filters.utcToLocalDateFilter(time_sheet_list[i].break1_start_datetime) : '',

                                        break1_end_datetime: time_sheet_list[i].break1_end_datetime ? this.$options.filters.utcToLocalDateFilter(time_sheet_list[i].break1_end_datetime) : '',

                                        break2_start_datetime: time_sheet_list[i].break2_start_datetime ? this.$options.filters.utcToLocalDateFilter(time_sheet_list[i].break2_start_datetime) : '',

                                        break2_end_datetime: time_sheet_list[i].break2_end_datetime ? this.$options.filters.utcToLocalDateFilter(time_sheet_list[i].break2_end_datetime) : '',

                                        break_duration: time_sheet_list[i].total_breaks,

                                        shift_duration: time_sheet_list[i].total_duration,
                                        overtime_duration: time_sheet_list[i].total_overtime,

                                        shift_start_distance: time_sheet_list[i].shift_start_distance,
                                        shift_end_distance: time_sheet_list[i].shift_end_distance,
                                        cur_activity: time_sheet_list[i].cur_activity,
                                        scheduled_breaks: [],

                                        weekoff: time_sheet_list[i].weekoff,
                                        leave: time_sheet_list[i].leave,
                                        no_shift: time_sheet_list[i].no_shift,
                                        timesheet_id: time_sheet_list[i].timesheet_id,
                                        is_toggled: false,
                                        actual_total_cost: time_sheet_list[i].actual_total_cost,
                                        late_by: time_sheet_list[i].late_by,
                                        early_left_by: time_sheet_list[i].early_left_by,

                                        // filled details for edit inputs
                                        edit_timesheet_start_hours: time_sheet_list[i].shift_start_datetime ? (this.$options.filters.utcToLocalDateFilter(time_sheet_list[i].shift_start_datetime)) : '',

                                        edit_timesheet_end_hours: time_sheet_list[i].shift_end_datetime ? (this.$options.filters.utcToLocalDateFilter(time_sheet_list[i].shift_end_datetime)) : '',

                                        edit_timesheet_break1_start_hours: time_sheet_list[i].break1_start_datetime ? this.$options.filters.utcToLocalDateFilter(time_sheet_list[i].break1_start_datetime) : '',

                                        edit_timesheet_break1_end_hours: time_sheet_list[i].break1_end_datetime ? this.$options.filters.utcToLocalDateFilter(time_sheet_list[i].break1_end_datetime) : '',

                                        edit_timesheet_break2_start_hours: time_sheet_list[i].break2_start_datetime ? this.$options.filters.utcToLocalDateFilter(time_sheet_list[i].break2_start_datetime) : '',

                                        edit_timesheet_break2_end_hours: time_sheet_list[i].break2_end_datetime ? this.$options.filters.utcToLocalDateFilter(time_sheet_list[i].break2_end_datetime) : '',

                                        edit_timesheet_function: ''
                                    }


                                    // checked shift start time and end time if is in time slot and emp has actual (timesheet) shift start time

                                    let schedule_start_time = emp_obj.schedule_start_time ? emp_obj.schedule_start_time : emp_obj.shift_start_datetime;

                                    // console.log('schedule_start_time', schedule_start_time, emp_obj.employee, emp_obj.shift_start_datetime);

                                    if(schedule_start_time >= time_slots[time].start_time && schedule_start_time < time_slots[time].end_time && emp_obj.shift_date == moment().format('YYYY-MM-DD')){

                                        // console.log('emp_obj', emp_obj)

                                        time_obj.emp_list.push(emp_obj);

                                    }else if(schedule_start_time < time_slots[time].start_time && emp_obj.shift_date != moment().format('YYYY-MM-DD') && !time_obj.backdated_start_time_emp_list.some(emp => emp.employee == emp_obj.employee)){

                                        // console.log('emp_obj', emp_obj, emp_obj.shift_date, moment().format('YYYY-MM-DD'));
                                        // checked start time is lower than time slot's start time and  already not pushed in list

                                        time_obj.backdated_start_time_emp_list.push(emp_obj);

                                    }else if(emp_obj.shift_date == moment().format('YYYY-MM-DD') && emp_obj.weekoff && !emp_obj.leave && !emp_obj.no_shift && !emp_obj.shift_start_datetime && !temp_weekly_off_assigned_emp_list.some(emp => emp.employee == emp_obj.employee)){

                                        temp_weekly_off_assigned_emp_list.push(emp_obj);

                                    }else if(emp_obj.shift_date == moment().format('YYYY-MM-DD') && !emp_obj.weekoff && emp_obj.leave && !emp_obj.no_shift && !emp_obj.shift_start_datetime && !temp_leave_assigned_emp_list.some(emp => emp.employee == emp_obj.employee)){

                                        temp_leave_assigned_emp_list.push(emp_obj);

                                    }else if(emp_obj.shift_date == moment().format('YYYY-MM-DD') && !emp_obj.weekoff && !emp_obj.
                                    leave && emp_obj.no_shift && !emp_obj.shift_start_datetime && !temp_emp_list.some(emp => emp.employee == emp_obj.employee)){

                                        temp_emp_list.push(emp_obj);
                                    }
                                }

                                // console.log(time_obj)
                                temp_time_sheet_list.push(time_obj);
                                // console.log(time_obj.backdated_start_time_emp_list)
                            }

                            this.time_sheet_list = temp_time_sheet_list;
                            this.weekly_off_assigned_emp_list = temp_weekly_off_assigned_emp_list;
                            this.leave_assigned_emp_list = temp_leave_assigned_emp_list;
                            this.employee_list = temp_emp_list;
                        }

                    }
                }))
                .catch(err => {
                    console.log(err);
                    this.is_timesheet_loading = false;
                })
                .finally(() => {
                    this.is_timesheet_loading = false;
                });
            }
        },

        assignShiftToSelectedEmp(emp_obj, new_status){
            this.is_timesheet_loading = true; //enabled loader

            this.changeCurrentShiftStatus(emp_obj, new_status);   //called api to change status of selected emp




            // ######################################################## old structure  ###########################
            // // split shift duration
            // let hours = emp_obj.prefer_shift_duration.slice(0,2);
            // let minutes = emp_obj.prefer_shift_duration.slice(3,5);

            // // add hours and minutes
            // let added_hours = moment().add(hours, 'hours').format('YYYY-MM-DD HH:mm:ss');
            // let added_minutes = moment(added_hours).add(minutes, 'minutes').format('YYYY-MM-DD HH:mm');

            // // calculate start and end time
            // let start_time = moment().format('YYYY-MM-DD HH:mm') + ':00';
            // let end_time = moment(added_minutes).format('YYYY-MM-DD HH:mm:ss');

            // console.log(start_time, end_time)

            // let new_shiftparams = {
            //     id: null,
            //     store: emp_obj.outlet,
            //     partner: emp_obj.employee,
            //     start_time: start_time,
            //     end_time: end_time,
            //     auto_sheduled: false,
            //     for_date: moment().format("YYYY-MM-DD"),
            //     function: emp_obj.function,
            //     overtime: '00:00:00',
            //     notes: ""
            // };

            // this.is_timesheet_loading = true; //enabled loader

            // LabourPalnningService.saveShiftOfEmployeeNetworkCallBack(new_shiftparams)
            //     .then(response => {
            //     	if (response.status == 201) {
            //             // after adding shift passed emp obj and status to change status api
            //             this.changeCurrentShiftStatus(emp_obj, new_status);   //called api to change status of selected emp
            //     	} else {
            //            this.is_timesheet_loading = false;   //disabled loader
            //         }
            //     })
            //     .catch((e) =>{
            //         console.log('error', e);
            //         this.is_timesheet_loading = false;   //disabled loader
            //     })
        },

        changeCurrentShiftStatus(emp_obj, new_status){
            if(Object.keys(emp_obj).length){

                this.is_timesheet_loading = true;   //enabled loader

                let params = {
                    employee: emp_obj.user_id,
                    outlet: emp_obj.outlet,
                    activity: new_status,
                    shift_date: emp_obj.shift_date,
                    // datetime: moment().format('YYYY-MM-DD HH:mm:ss'),
                    distance: null,
                    location: null,
                    lat: null,
                    long: null,
                    note: null
                }

                LabourPalnningService.changeTimesheetShiftStatus(params)
                .then(response => {
                	if (response.status == 201) {
                        this.getTodaysTimesheetDetails();   //called get timesheet api to get updated shifts
                	} else {
                       this.is_timesheet_loading = false;   //disabled loader
                    }
                })
                .catch((e) =>{
                    console.log('error', e);
                    this.is_timesheet_loading = false;   //disabled loader
                })
            }
        },

        updateTimesheet(emp_obj){
            if(emp_obj.edit_timesheet_start_hours || emp_obj.edit_timesheet_end_hours || emp_obj.edit_timesheet_break1_start_hours || emp_obj.edit_timesheet_break1_end_hours || emp_obj.edit_timesheet_break2_start_hours || emp_obj.edit_timesheet_break2_end_hours){

                let activities = [];
                // any activity of break 1 then activity_num is 1
                // any activity of break 2 then activity_num is 2
                // any activity of start shift or end shift then activity_num is 1

                // according to acitivies pushed activiy object to acitivies list

                // there are 6 activies to edit
                for(let i=0; i<6; i++){
                    let obj = {
                        employee: '',
                        outlet: '',
                        activity: '',
                        activity_num: '',
                        shift_date: '',
                        datetime: '',
                        distance: null,
                        location: null,
                        lat: null,
                        long: null,
                        note: null
                    };

                    if(i==0 && emp_obj.edit_timesheet_start_hours){
                        obj.employee = emp_obj.user_id;
                        obj.outlet = emp_obj.outlet;
                        obj.shift_date = emp_obj.shift_date;
                        obj.activity = 'shift_start';
                        obj.activity_num = 1;
                        obj.datetime = moment.utc(emp_obj.edit_timesheet_start_hours).format('YYYY-MM-DD HH:mm');
                        activities.push(obj);
                    }

                    if(i==1 && emp_obj.edit_timesheet_end_hours){
                        obj.employee = emp_obj.user_id;
                        obj.outlet = emp_obj.outlet;
                        obj.shift_date = emp_obj.shift_date;
                        obj.activity = 'shift_end';
                        obj.activity_num = 1;
                        obj.datetime = moment.utc(emp_obj.edit_timesheet_end_hours).format('YYYY-MM-DD HH:mm');
                        activities.push(obj);
                    }

                    if(i==2 && emp_obj.edit_timesheet_break1_start_hours){
                        obj.employee = emp_obj.user_id;
                        obj.outlet = emp_obj.outlet;
                        obj.shift_date = emp_obj.shift_date;
                        obj.activity = 'break_start';
                        obj.activity_num = 1;
                        obj.datetime = moment.utc(emp_obj.edit_timesheet_break1_start_hours).format('YYYY-MM-DD HH:mm');
                        activities.push(obj);
                    }

                    if(i==3 && emp_obj.edit_timesheet_break1_end_hours){
                        obj.employee = emp_obj.user_id;
                        obj.outlet = emp_obj.outlet;
                        obj.shift_date = emp_obj.shift_date;
                        obj.activity = 'break_end';
                        obj.activity_num = 1;
                        obj.datetime = moment.utc(emp_obj.edit_timesheet_break1_end_hours).format('YYYY-MM-DD HH:mm');
                        activities.push(obj);
                    }

                    if(i==4 && emp_obj.edit_timesheet_break2_start_hours){
                        obj.employee = emp_obj.user_id;
                        obj.outlet = emp_obj.outlet;
                        obj.shift_date = emp_obj.shift_date;
                        obj.activity = 'break_start';
                        obj.activity_num = 2;
                        obj.datetime = moment.utc(emp_obj.edit_timesheet_break2_start_hours).format('YYYY-MM-DD HH:mm');
                        activities.push(obj);
                    }

                    if(i==5 && emp_obj.edit_timesheet_break2_end_hours){
                        obj.employee = emp_obj.user_id;
                        obj.outlet = emp_obj.outlet;
                        obj.shift_date = emp_obj.shift_date;
                        obj.activity = 'break_end';
                        obj.activity_num = 2;
                        obj.datetime = moment.utc(emp_obj.edit_timesheet_break2_end_hours).format('YYYY-MM-DD HH:mm');
                        activities.push(obj);
                    }
                }

                // console.log('activities', activities);

                this.is_timesheet_loading = true;   //enabled loader

                LabourPalnningService.updateTodaysTimesheetInBulkNetworkCallBack({activities : activities})
                    .then(response => {
                        if (response.status == 200) {
                            this.getTodaysTimesheetDetails();   //called get timesheet api to get updated shifts
                        }else{
                            activities = [];
                            this.is_timesheet_loading = false;   //disabled loader
                        }
                    })
                    .catch((e) =>{
                        console.log('error', e);
                        activities = [];
                        this.is_timesheet_loading = false;   //disabled loader
                    })
            }else{
                this.$notify.error({
                    title: "Errror",
                    message: 'Please select input first'
                });
            }

        },

        deleteTimesheet(emp_obj){
            this.is_timesheet_loading = true;   //enabled loader

            LabourPalnningService.deleteTimesheetInBulkNetworkCallBack({id : emp_obj.timesheet_id})
                .then(response => {
                    if (response.status == 204) {
                        this.getTodaysTimesheetDetails();   //called get timesheet api to get updated shifts
                    }else{
                        this.is_timesheet_loading = false;   //disabled loader
                        this.$notify.error({
                            title: "Fail",
                            message: "Something Went Wrong"
                        });
                    }
                })
                .catch((e) =>{
                    console.log('error', e);
                    this.is_timesheet_loading = false;   //disabled loader
                })
        },

        // confirmation dialog to remove weekly off and leave
        // params - selected emp obj, action e.g. remove weekly off or leave and status of emp that needs to be changed
        openConfirmation(emp_obj, action_type, new_status){
            if (action_type == "REMOVE_WEEKLY_OFF") {
				this.$confirm(
					"Employee selected  is on weekly off. </br> Do you wish to remove?",
					"Alert",
					{
						confirmButtonText: "OK",
						cancelButtonText: "Cancel",
						dangerouslyUseHTMLString: true
					}
				)
					.then(() => {
						// this.removedWeeklyOffAndLeave(emp_obj, action_type, new_status);
						this.changeCurrentShiftStatus(emp_obj, new_status);
					})
					.catch(() => {});
			}else if (action_type == "REMOVE_LEAVE") {
                this.$confirm(
                    "Employee selected  is on Leave. </br> Do you wish to remove?",
					"Alert",
					{
						confirmButtonText: "OK",
						cancelButtonText: "Cancel",
						dangerouslyUseHTMLString: true
					}
				)
					.then(() => {
                        // this.removedWeeklyOffAndLeave(emp_obj, action_type, new_status);
                        this.changeCurrentShiftStatus(emp_obj, new_status);
					})
					.catch(() => {});
			}
        },

        //api to remove weekly off and leave of emp
		removedWeeklyOffAndLeave(emp_obj, action_type, new_status) {
            // this.is_timesheet_loading = true;   //enabled loader

			if (action_type == "REMOVE_WEEKLY_OFF") {

                let weekly_assigned_emp_list = [];

				this.weekly_off_assigned_emp_list.forEach(item => {
					if (item.employee != emp_obj.employee) {
                        let obj = {
                            auto_sheduled: true,
                            date: item.shift_date,
                            employee: item.employee,
                            id: item.weekly_off_id,
                            store: item.outlet,
                        }

                        weekly_assigned_emp_list.push(obj);
					}
				});

                let params = {
					data: weekly_assigned_emp_list,
					store: emp_obj.outlet,
					start_date: moment().format("YYYY-MM-DD"),
					end_date: moment().format("YYYY-MM-DD")
				};

                console.log('params', params);
				LabourPalnningService.saveWeeklyOffNetworkCallBack(params)
                .then(response => {
                    if (response.status == 200) {
                        // after removing weekly off, assign shift to that emp and then change his status
                        this.assignShiftToSelectedEmp(emp_obj, new_status);
                    }else{
                        this.is_timesheet_loading = false;   //disabled loader
                    }
                })
                .catch(err => {
                    console.log(err);
                    this.is_timesheet_loading = false;   //disabled loader
                });

			} if (action_type == "REMOVE_LEAVE") {
                console.log('REMOVE_LEAVE', emp_obj);

                let obj = {};
				obj.store = emp_obj.outlet;
				obj.employee = emp_obj.employee;
				obj.leave_type = emp_obj.leave_obj.leave_type;
				obj.is_paid = emp_obj.leave_obj.is_paid;
				obj.start_date = moment().format("YYYY-MM-DD");
				obj.end_date = moment().format("YYYY-MM-DD");
				obj.total_days = 1;
				obj.description = emp_obj.leave_obj.description;

				LabourPalnningService.deleteLeaveOfEmployeeNetworkCallBack(obj)
					.then(response => {
						if (response.status == 200) {
                            // after removing leave, assign shift to that emp and then change his status
                            this.assignShiftToSelectedEmp(emp_obj, new_status);
						}else{
                            this.is_timesheet_loading = false;   //disabled loader
                        }
					})
					.catch(err => {
						console.log(err);
                        this.is_timesheet_loading = false;   //disabled loader
					});
			}
		},


        completeTimesheetDetails(params){
            return LabourPalnningService.completeTimesheetDetailskNetworkCallBack(params)
            .then(response => {
                return response;
            })
            .catch((e) =>{
                console.log('error', e);
            })
        },

        getStoreTime(params){
            return LabourPalnningService.storeOpenCloseTime(params)
            .then(response => {
                return response;
            })
            .catch((e) =>{
                console.log('error', e);
            })
        },
    },

    beforeDestroy(){
        let obj = {
            scheduled_labour_hours: '',
            scheduled_labour_cost: '',
            actual_labour_hours: '',
            actual_labour_cost: '',
            total_leaves: '',
            total_absents: '',
            total_late: '',
            total_weekly_off: '',
            total_overtime: '',
            total_early_out: '',
        }

        this.$store.commit('commitTimesheetSummary', obj);
    }
}
</script>

<style lang="scss" scoped>
.TodayTimeSheet{
    .timsheet-table {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;
        // border: 1px solid #bebebe;

        thead th {
            // height: 25px;
            line-height: 35px;
            height: 35px;
            text-align: left;
            color: #707070;
            background-color: #f2f2f2!important;
            text-transform: uppercase;
            font-size: 12px;
        }

        tbody td, thead th {
            width: 10.77%;
            float: left;
            text-align: center;
        }

        td{
            height: 85px;
            padding: 10px 0;
            font-size: 0.7rem;
        }

        tbody tr{
            border-bottom: 1px solid #eee;
        }

        .title{
            font-weight: bold;
            font-size: 0.7rem;
        }
        .sub-title{
            color: #999;
        }
        .highliter{
            background-color: #f5f6fa;
            padding: 4px 10px;
            width: fit-content;
            margin: 0 auto;
            cursor: pointer;
        }
        .task-highliter{
            color: #fff;
            border-radius: 4px;
            padding: 3px 10px;
            font-size: 10px;
            font-weight: 600;
            width: fit-content;
            margin: 0 auto;
        }
    }

    thead, tbody, tr, td, th {
        display: block;
    }
    //   tbody tr{
    //     // border-bottom: 1px solid #bebebe;
    //   }
    tr:after {
        content: ' ';
        display: block;
        visibility: hidden;
        clear: both;
    }

    .text-center{
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .row-bg{
        height: 20px!important;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    label{
        font-size: 0.6rem;
        // font-weight: 500;
        display: block;
        margin-bottom: 3px;
        color: #000;
        // text-align: left;
    }
    .action-btn {
        background-color: #E29D5A;
        border-color: #E29D5A;
        color: #fff;
    }
    .ellipsis{
        white-space: nowrap;
        width: 100px;
        overflow: hidden;
        text-overflow: ellipsis;
        margin: 0 auto;
    }
}
</style>
<style lang="scss">
.scheduled-shift-table {
    table-layout: fixed;
    width: 100%;
    thead {
        // display: table; /* to take the same width as tr */
        // width: calc(100% - 14px); /* - 17px because of the scrollbar width */
        border-bottom: 1px solid #ddd;
    }
    tbody{
        // display: block;
        // max-height: 200px;
        // overflow-y: auto;
    }
    // tr {
    //     display: table; /* display purpose; th's border */
    //     width: 100%;
    //     box-sizing: border-box; /* because of the border (Chrome needs this line, but not FF) */
    // }
    th, td{
        text-align: center;
        width: 50%;
        font-size: 11px;
        padding: 5px;
        text-align: center;
    }
    th:first-child, td:first-child{
        text-align: left;
    }
}
.option-menu{
    font-size: 0.9rem;
    padding: 5px 0;
    cursor: pointer;
}
.option-menu:hover{
    color: #E29D5A;
}
.TodayTimeSheet{
    .el-message-box__btns{
        .el-button--primary{
            background-color: #E29D5A!important;
            border-color: #E29D5A!important;
        }
    }
}
</style>
